<div class=" header bg-gradient-nhc-orange pb-6 position-relative z-index-0">
  <div class=" container-fluid">
    <div class=" header-body">
      <div class=" row align-items-center py-4">
      </div>
    </div>
  </div>
</div>
<div class="container mt--7 position-relative z-index-1">
  <h1 class="text-center mb-4 text-white" style="font-size: 2.5rem;">Frequently Asked Questions</h1>
  <div class="accordion">
    <div *ngFor="let faq of faqs" class="card">
      <div (click)="toggleCollapse(faq)" class="card-header">
        <div class="mb-0">
          <div>
            <h2>{{ faq.question }}</h2>
          </div>
        </div>
      </div>
      <div [collapse]="faq.isCollapsed" class="card-body">
        {{ faq.answer }}
        <div *ngFor="let fc of faq.faq" class="card">
          <div (click)="toggleCollapse(fc)" class="card-header">
            <div class="mb-0">
              <div class="pr-5">
                <h3>
                  {{ fc.question }}
                </h3></div>
            </div>
          </div>
          <div [collapse]="fc.isCollapsed" class="card-body">
            <p>{{ fc.answer }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
